import { Loader } from "@googlemaps/js-api-loader";

export function handleResponse(res) {
  let obj = {};
  if (res.data && typeof res.data == typeof {}) {
    obj.data = res.data;
    if (res.data.data) {
      obj.data = res.data.data;
    }
    if (
      res.data.count != null ||
      res.data.count != undefined ||
      res.data.count != ""
    ) {
      obj.count = res.data.count;
    }
  } else {
    obj = res;
  }
  return obj;
}

export function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function loadGoogleInstance() {
  if (!window.google || !window.google.maps) {
    const loader = new Loader({
      apiKey: process.env.VUE_APP_MAP_KEY,
      version: "weekly",
      libraries: ["places", "geometry", "drawing"],
    });
    loader.load();
  }
}

export function handleError(err) {
  console.log(err);
  let obj = {};
  if (err.response && err.response.data) {
    obj.data = err.response.data;
    if (obj.data.error) {
      obj.data = err.response.data.error;
    }
  } else {
    obj.response = err.response;
  }
  obj.status = err.response.status;
  return obj;
}

export function convertToBlobAndDownload(data, filename) {
  const url = window.URL.createObjectURL(
    new Blob([data], { type: "application/octetstream" })
  );
  var a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export function downloadBlob(blob, fileName, fileType) {
  let url = window.URL.createObjectURL(blob);

  let a = document.createElement("a");

  a.href = url;
  a.download = `${fileName}${fileType}`;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function isPrimitive(val) {
  return !(typeof val == "object" || typeof val == "function");
}

export function generatedFormData(obj, skipKeys = []) {
  let formData = new FormData();
  if (obj && typeof obj == "object") {
    Object.entries(obj).map(([key, value]) => {
      if (Array.isArray(value)) {
        value = value.join(",");
      }
      if (key == "coordinates") {
        value = JSON.stringify(value);
      }
      if (skipKeys.indexOf(key) == -1) {
        if (value !== "" && value !== null) {
          formData.append(key, value);
        }
      } else {
        formData.append(key, null);
      }
    });
  }
  return formData;
}

export function emailValidation(string) {
  let validRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return validRegex.test(string);
}

export function nameValidation(string) {
  let validRegex = /^[a-zA-Z0-9]+$/i;
  return validRegex.test(string);
}

export function usernameValidation(string) {
  let validRegex = /^[a-zA-Z0-9_]+$/i;
  return validRegex.test(string);
}

export function referenceValidation(string) {
  let validRegex = /^[a-zA-Z0-9_-]+$/i;
  return validRegex.test(string);
}

export function tripReferenceValidation(string) {
  let validRegex = /^[a-zA-Z0-9_-]+$/i;
  return validRegex.test(string);
}

export function branchCodeValidation(string) {
  let validRegex = /^[a-zA-Z0-9_.-]+$/i;
  return validRegex.test(string);
}

export function warehouseIdValidation(string) {
  let validRegex = /^[a-zA-Z0-9_.-]+$/i;
  return validRegex.test(string);
}

export function itemNumberValidation(string) {
  let validRegex = /^[a-zA-Z0-9_.-]+$/i;
  return validRegex.test(string);
}

export function projectCodeValidation(string) {
  let validRegex = /^[a-zA-Z0-9_.-]+$/i;
  return validRegex.test(string);
}

export function customerNameValidation(string) {
  let validRegex = /^[a-zA-Z0-9 _.-]+$/i;
  return validRegex.test(string);
}
export function customerCodeValidation(string) {
  let validRegex = /^[a-zA-Z0-9_.-]+$/i;
  return validRegex.test(string);
}

export function locationIdValidation(string) {
  let validRegex = /^[a-zA-Z0-9_.-]+$/i;
  return validRegex.test(string);
}

export function returnToday(addDays = 0) {
  let today = new Date();
  today.setDate(today.getDate() + addDays);
  return getDateTime(today);
}

export function getDateTime(_d) {
  let _ = new Date(_d),
    date = _.getDate() < 10 ? "0" + _.getDate() : _.getDate(),
    month = _.getMonth() + 1,
    year = _.getFullYear();

  month = month < 10 ? "0" + month : month;

  return [year, month, date].join("-");
}

// Used in Google map
export function generateListOfHtmlTag(key, value) {
  return `<li class="pb-1 ma-0">
              <span class="text-primary text-caption font-weight-bold text-capitalize">${key.replace(
                /_/g,
                " "
              )} :</span>
              <span class="text-primary text-caption"> ${value}</span>
          </li>`;
}

export function getFilterFromLocalStorage(key) {
  let filters = localStorage.getItem(key);
  if (!filters) {
    filters = {};
  }
  if (typeof filters == typeof "string") {
    filters = JSON.parse(filters);
  }
  return filters;
}

export function getEmptyObjectKeyRemove(obj) {
  if (typeof obj == typeof {}) {
    for (const [key, value] of Object.entries(obj)) {
      //  === used because boolean false should not be considered as negating value
      if (value === null || value === undefined || value === "") {
        delete obj[key];
      }
    }
  }
  return obj;
}

export function getChoicesFromOptionsRequest(key, response) {
  if (response?.actions?.POST[key]) {
    return response?.actions?.POST[key]["choices"];
  } else {
    return [];
  }
}

export function getOrderStatusColor(status, needTextColor = false) {
  if (status && typeof status == "string") {
    status = status.toLowerCase();
  }
  switch (status) {
    case "open_transaction":
      return needTextColor ? "" : "open_transaction";
    case "unassigned":
      return needTextColor ? "unassigned white--text" : "unassigned";
    case "assigned":
      return needTextColor ? "assigned white--text" : "assigned";
    case "pickedup":
      return needTextColor ? "pickedup white--text" : "pickedup";
    case "picked up":
    case "picked_up":
      return needTextColor ? "pickedup white--text" : "pickedup";
    case "not_pickedup":
      return needTextColor ? "not_pickedup text_color--text" : "not_pickedup";
    case "partially_delivered":
      return needTextColor
        ? "partially_delivered white--text"
        : "partially_delivered";
    case "partially delivered":
      return needTextColor
        ? "partially_delivered white--text"
        : "partially_delivered";
    case "enroute":
      return needTextColor ? "enroute text_color--text" : "enroute";
    case "out for delivery":
    case "out_for_delivery":
      return needTextColor ? "enroute text_color--text" : "enroute";
    case "on_hold":
      return needTextColor ? "on_hold white--text" : "on_hold";
    case "returned":
      return needTextColor ? "returned white--text" : "returned";
    case "cancelled":
      return needTextColor ? "cancelled white--text" : "cancelled";
    case "delivered":
      return needTextColor ? "delivered white--text" : "delivered";
    case "not_delivered":
      return needTextColor ? "not_delivered white--text" : "not_delivered";
    case "not delivered":
      return needTextColor ? "not_delivered white--text" : "not_delivered";
  }
}

export function tripStatusColor(status, needTextColor = false) {
  if (status && typeof status == "string") {
    status = status.toLowerCase();
  }
  switch (status) {
    case "unallocated":
      return needTextColor
        ? "open_transaction text_color--text"
        : "open_transaction";
    case "loading":
      return needTextColor ? "trip_loading text_color--text" : "trip_loading";
    case "scheduled":
      return needTextColor ? "unassigned white--text" : "unassigned";
    case "active":
      return needTextColor ? "trip_active white--text" : "trip_active";
    case "paused":
      return needTextColor ? "pickedup white--text" : "pickedup";
    case "cancelled":
      return needTextColor ? "cancelled white--text" : "cancelled";
    case "completed":
      return needTextColor ? "delivered white--text" : "delivered";
  }
}

export function orderTextChange(orderStatus) {
  switch (orderStatus) {
    case "open_transaction":
      return "Open Transaction";
    case "unassigned":
      return "Unassigned";
    case "assigned":
      return "Assigned";
    case "pickedup":
      return "Pickedup";
    case "partially_delivered":
      return "Partially Delivered";
    case "out for delivery":
      return "Out For delivery";
    case "enroute":
      return "Out For delivery";
    case "on_hold":
      return "On Hold";
    case "returned":
      return "Returned";
    case "cancelled":
      return "Cancelled";
    case "delivered":
      return "Delivered";
    case "not delivered":
      return "Not delivered";
    case "not_delivered":
      return "Not delivered";
    case "not_pickedup":
      return "Not Pickedup";
  }
}

export function changeTheme(
  object,
  vuetifyObj,
  keysToIgnore = ["company", "id", "theme", "name"]
) {
  if (Object.keys(object).length > 0) {
    Object.keys(object).forEach((i) => {
      if (keysToIgnore.indexOf(i) == -1) {
        vuetifyObj.theme.themes.light[i] = object[i];
      }
    });
  }
}

export let defaultTheme = {
  primary: "#1976D2",
  secondary: "#424242",
  accent: "#82B1FF",
  error: "#FF5252",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FB8C00",
  heading: "#90a4ae",
  background_color: "#E9F2F1",

  subHeading: "#cfd8dc",
  background_color: "#E9F2F1",

  open_transaction: "#DBDBDB",
  unassigned: "#607D8B",
  assigned: "#795548",
  enroute: "#80CBC4",
  pickedup: "#FF9800",
  not_pickedup: "#FDD835",
  delivered: "#4CAF50",
  not_delivered: "#F44336",
  partially_delivered: "#E91E63",
  failed: "#F44336",
  returned: "#333333",
  trip_loading: "#9C27B0",
  loading_completed: "#9C27B0",
  on_hold: "#9C27B0",
  cancelled: "#F48FB1",
  trip_active: "#2196F3",
};

export function getUserDetailsLocalStorage() {
  return JSON.parse(localStorage.getItem("user_data"));
}

export function isCompanyHasItems() {
  let userData = JSON.parse(localStorage.getItem("user_data"));
  let hasItem = false;
  if (
    userData &&
    userData.company_details &&
    userData.company_details.configuration
  ) {
    hasItem = userData.company_details.configuration.has_items;
  }
  return hasItem;
}

export function getGenerateStatistics(trip) {
  let statistics = {};
  if (trip?.order_statistics) {
    statistics.total_volume = trip.order_statistics.volume;
    statistics.total_weight = trip.order_statistics.weight;
  }
  if (trip?.trip_statistics) {
    statistics.total_distance = trip.trip_statistics.distance;
    statistics.travelling_time = trip.trip_statistics.travelling_time;
    statistics.total_time = trip.trip_statistics.total_time;
  }
  return statistics;
}

export function getGenerateVehicleChatData(vehicle) {
  let vehicleChart = {};
  vehicleChart = {
    labels: ["Chilled", "dry", "frozen"],
    datasets: [
      {
        label: "Fill Ratio",
        data: [vehicle.chilled, vehicle.dry, vehicle.frozen],
        backgroundColor: ["#e6e7e8", "#D7CCC8", "#FFCDD2"],
      },
    ],
  };
  return vehicleChart;
}

export function tiaResponseModification(trip) {
  trip.statistics = getGenerateStatistics(trip);
  if (
    trip?.recommended_assets_statistic &&
    trip.recommended_assets_statistic.length > 0
  ) {
    trip.recommended_assets_statistic = trip.recommended_assets_statistic;
  } else {
    delete trip.recommended_assets_statistic;
  }
  return trip;
}

/**
 *
 * @param {Object} errorInstance
 * @param {String} key
 * @param {Number} index
 * @param {String} subKey
 * @param {Boolean} isDelete
 * @returns
 */
export function errorInSubArrayHandler(
  errorInstance,
  key,
  index,
  subKey,
  isDelete = false
) {
  return errorInstance &&
    errorInstance[key] &&
    errorInstance[key].length != 0 &&
    errorInstance[key][index] &&
    errorInstance[key][index][subKey]
    ? isDelete
      ? delete errorInstance[key][index][subKey]
      : errorInstance[key][index][subKey]
    : "";
}

export function checkifLoggedIn() {
  return !!localStorage.getItem("user");
}

export function getSupportStatusColorClass(value) {
  switch (value) {
    case "open":
      return "grey white--text";
    case "in_progress":
      return "warning lighten-1 ";
    case "resolved":
      return "green darken-5 ";
    case "acknowledge":
      return "pink lighten-3 ";
    case "reopen":
      return "success lighten-1";
    case "cancelled":
      return "error lighten-3 ";
    case "closed":
      return "secondary lighten-5 ";
    default:
      return "";
  }
}

export function getSupportImpactClass(value) {
  switch (value) {
    case "low":
      return "success lighten-2";
    case "minor":
      return "warning darken-4";
    case "critical":
      return "pink white--text  lighten-2";
    case "major":
      return "error  lighten-2";
    default:
      return "";
  }
}

export function getSupportPriorityClass(value) {
  switch (value) {
    case "low":
      return "success";
    case "medium":
      return "warning";
    case "high":
      return "pink white--text";
    default:
      return "";
  }
}

export function getAllUserPreferances() {
  let preferences = localStorage.getItem("userPreferences");
  if (preferences) {
    return JSON.parse(preferences);
  }
  return {};
}

export function getUserPreferances(key) {
  let preferences = getAllUserPreferances();
  // debugger
  if (preferences && preferences[key]) {
    return preferences[key];
  }
  return [];
}
export function customFieldDefaultData(fieldList) {
  let newField = {};
  fieldList.filter((field) => {
    if (field.field_type == "boolean_field") {
      newField[field.name] = field.default == "true" ? "true" : "false";
    } else if (field.default) {
      newField[field.name] = field.default;
    }
  });
  return newField;
}

export function formatDate(value, withTime) {
  if (value) {
    const _date = new Date(value);
    if (_date) {
      let date = _date.getDate();
      let month = _date.getMonth() + 1;
      let year = _date.getFullYear();
      date = date < 10 ? `0${date}` : `${date}`;
      month = month < 10 ? `0${month}` : `${month}`;
      let fullDate = [date, month, year].join("/");
      let time = [];
      if (withTime) {
        let hour = _date.getHours();
        let minute = _date.getMinutes();
        hour = hour < 10 ? `0${hour}` : `${hour}`;
        minute = minute < 10 ? `0${minute}` : `${minute}`;
        time = [hour, minute].join(":");
        fullDate = [fullDate, time].join(" ");
      }
      return fullDate;
    } else {
      return "";
    }
  }
  return "";
}
export function formatToLocalDate(value, withTime) {
  if (value) {
    const _date = new Date(value);
    if (_date) {
      let formattedDate = _date.toLocaleDateString();
      if (withTime) {
        formattedDate = _date.toLocaleString();
      }
      return formattedDate;
    } else {
      return "-";
    }
  }
  return "-";
}

export function setChartScales(xTitle, yTitle) {
  return {
    scales: {
      xAxes: [
        {
          stacked: true,
          scaleLabel: {
            display: true,
            labelString: xTitle,
            fontColor: "black",
            fontSize: 14,
          },
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            beginAtZero: true,
          },
          scaleLabel: {
            display: true,
            labelString: yTitle,
            fontColor: "black",
            fontSize: 14,
          },
        },
      ],
    },
  };
}

export function downloadFromUrl(url) {
  let a = document.createElement("a");
  a.href = url;
  a.target = "_black";
  a.click();
}

export default {
  formatDate,
  formatToLocalDate,
  getSupportStatusColorClass,
  getSupportImpactClass,
  getSupportPriorityClass,
  getOrderStatusColor,
  tripStatusColor,
  getUserDetailsLocalStorage,
  getEmptyObjectKeyRemove,
  getFilterFromLocalStorage,
  isCompanyHasItems,
};
